
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";




export function getMembership(
  RegistrationID,
  from = 0,
  size = 1000,
  option = "active",
  searchText = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/membership`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            from,
            size,
            option,
            searchText,
          },
        }
      );

      return {
        totalItemscount: response.data.totalItemscount,
        searchResult: response.data.MembershipData,
      };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function saveMembership(key, membership) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/crm/membership/${key}`,
          membership,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/crm/membership`,
          membership,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function deleteMembership(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/crm/membership/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
     
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function getActiveMemberships(registrationID) {
  return async (dispatch, getState) => {
    // return database.collection("Memberships").where("RegistrationID","==",registrationID).where("IsDeleted","==",false).orderBy("Name","asc").get().then((querySnapshot) => {
    //     const activeMemberships = []
    //     querySnapshot.forEach((doc) => {
    //         activeMemberships.push(
    //           {
    //             key:doc.id,...doc.data()
    //           }
    //         )
    //    })
    //  dispatch({ type: actionTypes.GET_ACTIVE_MEMBERSHIPS, activeMemberships })
    // }).catch((error) => {console.log(error)})
    const token = getState().user.uat;
    const response = await axios.get(constants.API_URL + "/setup/memebrship", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.data && response.data.activeMemberships) {
      let activeMemberships = response.data.activeMemberships;
      console.log("activeMemberships", activeMemberships);
      dispatch({ type: actionTypes.GET_ACTIVE_MEMBERSHIPS, activeMemberships });
    }
  };
}
